import { Column, Entity, OneToMany } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { ContactInformation } from '@nsk-app/models/contactInformation';
import { Topic } from '@nsk-app/models/topic';

@Entity('hospitals', {
  orderBy: {
    order: 'ASC'
  }
})
export class Hospital extends OrderedModel {

  @Column()
  name: string;

  @OneToMany(type => ContactInformation, contact => contact.hospital, {eager: true})
  contacts: ContactInformation[];

  @OneToMany(type => Topic, topic => topic.hospital, {eager: true})
  topics: Topic[];

}
